import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import OTPEntry from '@/components/OTPEntry';
import JoinNowModal from '@/components/JoinNowModal';
import CollaboratorJoinModal from '@/components/CollaboratorJoinModal';
import customerApi from '@/lib/marketplaceCustomerApi';

export default function UnifiedSignIn() {
  const location = useLocation();
  const navigate = useNavigate();
  const [proof, setProof] = useState(location.state?.proof || null);
  const [role, setRole] = useState(location.state?.selectedRole || '');
  const [name, setName] = useState('');
  const [email, setEmail] = useState(location.state?.proof?.email || '');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const close = () => { setProof(null); setRole(''); };
  return <main className="min-h-screen bg-slate-50 px-4 pb-16 pt-28"><section className="mx-auto max-w-xl rounded-2xl bg-white p-6 shadow">
    <h1 className="text-3xl font-bold mb-5">Sign in or join KalaManch</h1>
    {!proof && <OTPEntry onProof={(value, selected) => { setProof(value); setEmail(value.email || ''); setRole(selected); }} />}
    {proof && role === 'artist' && <JoinNowModal isOpen onClose={close} initialProof={proof} />}
    {proof && role === 'collaborator' && <CollaboratorJoinModal isOpen onClose={close} initialProof={proof} />}
    {proof && role === 'customer' && <form className="space-y-4" onSubmit={async event => {
      event.preventDefault(); setBusy(true); setError('');
      try {
        await customerApi.post('/register', { phone: proof.mobile, email, name, verified_mobile_token: proof.verified_mobile_token });
        const returnTo = location.state?.returnTo || '';
        navigate(/^\/marketplace\/product\/[a-zA-Z0-9_-]+$/.test(returnTo) ? `${returnTo}?checkout=1` : '/marketplace/account', { replace: true });
      } catch (err) { setError(typeof err.response?.data?.detail === 'string' ? err.response.data.detail : 'Could not create account. Please try again.'); }
      finally { setBusy(false); }
    }}>
      <h2 className="text-xl font-semibold">Complete your customer profile</h2>
      <p>{proof.mobile}</p>
      <label className="block">Name<input className="border p-3 w-full" required maxLength={160} value={name} onChange={event => setName(event.target.value)} /></label>
      <label className="block">Email<input className="border p-3 w-full" required type="email" value={email} onChange={event => setEmail(event.target.value)} /></label>
      {error && <p role="alert">{error}</p>}
      <button className="btn-primary" disabled={busy}>Create customer account</button>
    </form>}
    <Link to="/" className="block mt-5 underline">Back to home</Link>
  </section></main>;
}
